var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 282.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.5,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.763,0C124.234,0 35.821,59.182 0,142.721C35.821,226.261 124.234,285.442 227.763,285.442C331.292,285.442 419.705,226.261 455.526,142.721C419.705,59.182 331.292,0 227.763,0ZM227.763,237.869C170.615,237.869 124.234,195.243 124.234,142.721C124.234,90.2 170.615,47.574 227.763,47.574C284.911,47.574 331.292,90.2 331.292,142.721C331.292,195.243 284.911,237.869 227.763,237.869ZM227.763,85.633C193.392,85.633 165.646,111.132 165.646,142.721C165.646,174.31 193.392,199.81 227.763,199.81C262.135,199.81 289.88,174.31 289.88,142.721C289.88,111.132 262.135,85.633 227.763,85.633Z",
    style: {
      fill: "#0d5cb6",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightAlert);
export default __webpack_public_path__ + "static/media/flight-alert.921eac6a4d3107eed78305c5b6c7884e.svg";
export { ForwardRef as ReactComponent };